import type { SKANPostbacksConversionMappingState } from './SKANPostbacksConversionMapping.types';

export const INIT_STATE: SKANPostbacksConversionMappingState = {
  mappingLoading: true,
  targetEventsLoading: true,
  processing: false,
  error: null,
  savedMapping: {},
  currentMapping: {},
  savedTargetEvent: '',
  currentTargetEvent: '',
  skAdNetworkEnabled: null,
  targetEventsRecommendations: [],
  savedAscendingOnly: undefined,
  currentAscendingOnly: undefined,
  templateOptions: [],
  activeTemplateId: null,
  lastUpdate: null,
  mappingOptimizationsInfo: {
    optimizationsAvailable: undefined,
  },
};

export const APP_RECOMMENDED_MAPPING_TEMPLATE_OPTION_SKAN4_UPGRADE = 'Upgrade to SKAdNetwork 4.0';
export const APP_RECOMMENDED_MAPPING_TEMPLATE_OPTION_BRANCH_STANDARD = 'Branch Recommended (Standard)';
export const APP_RECOMMENDED_MAPPING_TEMPLATE_OPTION_BRANCH_ADVANCED = 'Branch Recommended (Advanced)';

export const APP_RECOMMENDED_MAPPING_TEMPLATE_OPTIONS = [APP_RECOMMENDED_MAPPING_TEMPLATE_OPTION_SKAN4_UPGRADE];

export const APP_RECOMMENDED_MAPPING_TOOLTIP_COMMON_TEXT =
  'It is generated specifically for this app using the current configuration.';
export const APP_RECOMMENDED_MAPPING_TOOLTIPS = {
  [APP_RECOMMENDED_MAPPING_TEMPLATE_OPTION_SKAN4_UPGRADE]:
    'Designed to increase adoption rates and ensure accuracy in Conversion Value mappings. ' +
    APP_RECOMMENDED_MAPPING_TOOLTIP_COMMON_TEXT,
  [APP_RECOMMENDED_MAPPING_TEMPLATE_OPTION_BRANCH_STANDARD]:
    'Designed to maximize adoption rates using the recommended, standard events. ' +
    APP_RECOMMENDED_MAPPING_TOOLTIP_COMMON_TEXT,
  [APP_RECOMMENDED_MAPPING_TEMPLATE_OPTION_BRANCH_ADVANCED]:
    'Designed to maximize adoption rates by considering all events and the statistics of transitions between them. ' +
    APP_RECOMMENDED_MAPPING_TOOLTIP_COMMON_TEXT,
};
